<!-- Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. -->

<!--
	Possibilities for this [ngClass] are:

		left-checkbox-layout-with-icons
		left-checkbox-layout-without-icons
		right-checkbox-layout-with-icons
		right-checkbox-layout-without-icons
-->
<div [ngClass]="overallLayoutCssClass$ | async">
	<!-- ICON -->
	<mat-icon
		*ngIf="icon$ | async as icon"
		class="checkbox-icon"
		(click)="handleClick()"
		[fontIcon]="icon"
		[ngStyle]="dynamicElementStyle$ | async"
		>{{ icon }}
	</mat-icon>

	<!-- LABEL -->
	<div class="checkbox-label" style="{{ 'font-size: ' + fontSize }}" (click)="handleClick()">
		{{ label$ | async }}
	</div>

	<!-- CHECKBOX (without label) -->
	<mat-checkbox
		[formControl]="checkboxFormControl"
		[indeterminate]="indeterminate$ | async"
		class="checkbox-box"
	>
	</mat-checkbox>
</div>
